import React from 'react'
import { FaUserPlus, FaCopyright, FaComments, FaDollarSign } from "react-icons/fa" 
import MacAndIphone from "../assets/png_stat_sitePerso.png"

export default function Stat() {
  return (
    <section className="homePresentation">
      <div className="grid">

        <div className="hire_reasons grid_el" id="section_reasons">
          <h2 className="title_deco"> Pourquoi faire appel à un spécialiste web ? </h2>
          <div className="reasons-box">
      
            <div className="reason">
              <div className="reason-icon"><FaUserPlus /></div>
              <div className="text">
                <h3 className="reason-title">Attirer de l'attention sur votre projet </h3>
              </div>
            </div>
            <div className="reason">
              <div className="reason-icon"><FaCopyright /></div>
              <div className="text">
                <h3 className="reason-title">Développer une image de marque haute qualité</h3>
              </div>
            </div>
            <div className="reason">
              <div className="reason-icon"><FaComments /></div>
              <div className="text">
                <h3 className="reason-title">Vous connecter avec vos clients facilement</h3>
              </div>
            </div>
            <div className="reason">
              <div className="reason-icon"><FaDollarSign /></div>
              <div className="text">
                <h3 className="reason-title">Profiter d'une réel présence sur le web</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="grid_el img" data-aos="fade-up" data-aos-duration="1000">
          <img src={MacAndIphone} alt="Mac and Iphone with website in it"/>
        </div>
      </div>
    </section>
  )
}
